import LikeJobs from "../../components/candidate/likesYou";

const LikesYouPage = () => {
  return <LikeJobs />;
};

export default LikesYouPage;
